// src/features/notifications/services/notifications.queryKeys.ts

export const NOTIFICATION_KEYS = {
    base: 'notifications',
    all: ['notifications'],
    list: (filters?: Record<string, unknown>) =>
        filters ? ['notifications', 'list', filters] : ['notifications', 'list'],
    detail: (id: string) => ['notifications', 'detail', id]
} as const;
